import React, { useState } from 'react';

import { Modal, Header, Body, Footer, FooterButton } from 'components/Modals/modalElements';
import DepartmentSetting from 'components/DepartmentSetting/DepartmentSetting';

export default React.memo(({ createDepartment, closeModal }) => {
  const [isOpen, setIsOpen] = useState(true);

  const hideModal = () => {
    setIsOpen(false);
    return closeModal && closeModal();
  };

  return (
    <Modal isOpen={isOpen}>
      <Header>Add New Department</Header>
      <Body>
        <DepartmentSetting isModal department={{}} createDepartment={createDepartment} />
      </Body>
      <Footer>
        <FooterButton label="Cancel" onClick={() => hideModal()} />
      </Footer>
    </Modal>
  );
});
